import script from "./EditFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./EditFeed.vue?vue&type=script&setup=true&lang=js"

import "./EditFeed.vue?vue&type=style&index=0&id=68ef403a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ef403a"]])

export default __exports__